import React from "react";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import CurrencyItems from "./currencyItems";
import PrevButton from "../../../assets/icons/back b-01.svg";
import NextButton from "../../../assets/icons/next b-01.svg";

const SwiperCurrency = ({ data }) => {
  const one_4 = data.slice(0, 4);
  const four_eight = data.slice(4, 8);
  const eight_twelve = data.slice(8, 12);
  const twelve_16 = data.slice(12, 16);

  const one_2 = data.slice(0, 2);
  const two_four = data.slice(2, 4);
  const four_sixt = data.slice(4, 6);
  const six_eight = data.slice(6, 8);
  const eight_ten = data.slice(8, 10);
  const ten_twelve = data.slice(10, 12);
  const twelve_fourteen = data.slice(12, 14);
  const fourteen_sixteen = data.slice(14, 16);

  return (
    <div>
      <div className="flex flex-row  w-[90%] mx-auto  h-[200px] my-auto  pt-8 screen500:pt-0 screen900:hidden ">
        <div className="swiper-prev  my-auto  mr-4  ">
          <img alt="قبلی" src={PrevButton} className="w-12 h-12 " />
        </div>

        <Swiper
          className=""
          spaceBetween={20}
          slidesPerView={1}
          speed={600}
          dir="rtl"
          loop={true}
          modules={[Navigation, Pagination, Scrollbar]}
          navigation={{
            prevEl: ".swiper-prev",
            nextEl: ".swiper-next",
          }}
        >
          <SwiperSlide>
            <div className=" grid grid-cols-4 justify-items-center    ">
              {one_4.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className=" grid grid-cols-4  justify-items-center  ">
              {four_eight.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-4  justify-items-center  ">
              {eight_twelve.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-4  justify-items-center  ">
              {twelve_16.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="swiper-next  my-auto ml-4  ">
          <img alt="بعدی" src={NextButton} className="w-12 h-12 " />
        </div>
      </div>





      <div
        className="screen900:flex flex-row  w-[70%] mx-auto  h-[200px] my-auto  pt-8 hidden
      screen750:w-[90%]
      screen600:w-[100%]
      "
      >
        <div className="swiper-prev h-10 screen500:h-14 my-auto  mr-4 screen600:mr-0  ">
          <img alt="قبلی" src={PrevButton} className="w-24 screen450:w-16  " />
        </div>

        <Swiper
          className=""
          spaceBetween={20}
          slidesPerView={1}
          speed={600}
          dir="rtl"
          loop={true}
          modules={[Navigation, Pagination, Scrollbar]}
          navigation={{
            prevEl: ".swiper-prev",
            nextEl: ".swiper-next",
          }}
        >
          <SwiperSlide>
            <div className=" grid grid-cols-2 justify-items-center   ">
              {one_2.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {two_four.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {four_sixt.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {six_eight.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {eight_ten.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {ten_twelve.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {twelve_fourteen.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" grid grid-cols-2  justify-items-center  ">
              {fourteen_sixteen.map((item) => {
                return <CurrencyItems key={item.id} items={item} />;
              })}
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="swiper-next h-10 screen500:h-14  my-auto ml-4 screen600:ml-0 ">
          <img alt="بعدی" src={NextButton} className="w-24 screen450:w-16  " />
        </div>
      </div>
    </div>
  );
};

export default SwiperCurrency;
